// extracted by mini-css-extract-plugin
export var active = "MultilanguageSelector-module--active--b2254";
export var icon = "MultilanguageSelector-module--icon--759d3";
export var link = "MultilanguageSelector-module--link--e0211";
export var menuLink = "MultilanguageSelector-module--menuLink--ca1bc";
export var nestedEntryOpen = "MultilanguageSelector-module--nestedEntryOpen--01599";
export var nestedItem = "MultilanguageSelector-module--nestedItem--f8925";
export var subMenuDesktop = "MultilanguageSelector-module--subMenuDesktop--7bd4e";
export var subMenuWrapperDesktop = "MultilanguageSelector-module--subMenuWrapperDesktop--d815e";